import Vue from 'vue'
import Vuex from 'vuex'
import {ClientTable} from 'vue-tables-2';

Vue.use(Vuex);
Vue.use(ClientTable, {
    perPage: 100,
    dropdownPagination: true,
    perPageValues: [10, 25, 50, 100, 1000],
    sortIcon: { base:'fa', up:'fa-sort-amount-up', down:'fa-sort-amount-down', is:'fa-sort'},
    useVuex: false,
    theme: 'bootstrap4'
});

let _ = require('lodash');

// Load store modules dynamically.
const requireContext = require.context('./modules', false, /.*\.js$/)

const modules = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
  )
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    return { ...modules, [name]: module }
  }, {})

export default new Vuex.Store({
  modules
})


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js